import { useRouter } from 'expo-router';
import { useSQLiteContext } from 'expo-sqlite';
import { useState } from 'react';
import { View } from 'react-native';

import { GoalForm } from '@/components/goals/GoalForm';
import { addGoal } from '@/lib/goals';
import { goBackOrTo } from '@/lib/nav';
import { getActiveProperty } from '@/lib/tasks';

export default function NewGoalScreen() {
  const router = useRouter();
  const db = useSQLiteContext();
  const [saving, setSaving] = useState(false);

  return (
    <View style={{ flex: 1 }}>
      <GoalForm
        mode="new"
        saving={saving}
        onCancel={() => goBackOrTo(router, '/projects')}
        onSubmit={async (input) => {
          setSaving(true);
          try {
            const prop = await getActiveProperty(db);
            if (!prop) return;
            await addGoal(db, { ...input, propertyId: prop.id });
            router.replace('/projects' as never);
          } finally {
            setSaving(false);
          }
        }}
      />
    </View>
  );
}
